module.exports = __webpack_public_path__ + "assets/create_project.20e77c46.svg";